import { render } from "./MobileEmulator.vue?vue&type=template&id=0cdd9885&scoped=true"
import script from "./MobileEmulator.vue?vue&type=script&lang=js"
export * from "./MobileEmulator.vue?vue&type=script&lang=js"

import "./MobileEmulator.vue?vue&type=style&index=0&id=0cdd9885&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cdd9885"]])

export default __exports__